import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { type TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useModifyCommuteInfo */
export type TypeModifyCommuteInfoParams = {
  /** 업무 시프트 */
  workShift: string;
  /** 연장근무 희망여부 */
  overWorkWishedStatus: string;
};

/** @category useModifyCommuteInfo */
export type TypeModifyCommuteInfoResponse = {
  code: string;
  message: string;
};

/**
 * @description 출근정보 수정 api 요청에 사용되는 커스텀 훅
 */
export const useModifyCommuteInfo = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeModifyCommuteInfoParams) => {
      const endpoint = '/commutes';
      return axiosInstance.patch<TypeModifyCommuteInfoResponse>(endpoint, params);
    },
  });

  const requestModifyCommuteInfo = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeModifyCommuteInfoParams;
    onSuccess?: (res: TypeModifyCommuteInfoResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestModifyCommuteInfo;
};
